module.exports = __webpack_public_path__ + "img/checkbox-off.cd4a86f2.svg";